////////////*Feature:Positive Feedback Function///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function initFeedbacks() {
  var feedbackContainers = $(".si-modal-container__js")
  var feedbackModals = $(".si-modal__js")
  var feedbackClosers = $(".si-feedback-closer__js")

  feedbackModals.on("click.prevent", function (e) {
    e.preventDefault();
    e.stopPropagation();
  });
  feedbackContainers.each(function (idx, feedback) {
    $(feedback).on('click.close', function () {
      Howler.stop()
      siAudio.sfx.click.play()

      switch (slides[globalVar.curSlide].type) {
        case "dnd":
          resetDnD(slides[globalVar.curSlide].revertTime, globalVar.dndAnswers);
          break
        case "sort":
          resetSort();
          break
        case "quiz":
          resetQuiz();
          break
        case "hotspot":
          resetHotspot();
          break
      }

      var classList = $(this).attr("class").split(/\s+/);
      $.each(classList, function (index, item) {
        closeFeedbackAction(item);
      });
      $("body").off("keydown.drag");
      $(this).hide().removeClass("si-current-modal");
      $("#si-nav-container").removeClass("feedback-open");
    })
  })
  feedbackClosers.each(function (idx, closer) {
    $(closer).on("click.close", function () {
      Howler.stop();
      siAudio.sfx.click.play();

      switch (slides[globalVar.curSlide].type) {
        case "dnd":
          resetDnD(slides[globalVar.curSlide].revertTime, globalVar.dndAnswers);
          break
        case "sort":
          resetSort();
          break
        case "quiz":
          resetQuiz();
          break
        case "hotspot":
          resetHotspot();
          break
      }

      var classList = $(feedbackContainers[idx]).attr("class").split(/\s+/);
      $.each(classList, function (index, item) {
        closeFeedbackAction(item);
      });
      $("body").off("keydown.drag");
      $(feedbackContainers[idx]).hide().removeClass("si-current-modal");
      $("#si-nav-container").removeClass("feedback-open");
    });
  });

}

function answerCorrect() {
  $('#' + globalVar.curSlide)
    .find('.si-positive')
    .fadeIn(FBKeyboard)
    .addClass('si-current-modal');

  var type = slides[globalVar.curSlide].type;
  slides[globalVar.curSlide][type]['trys'] = 0;

  if (siAudio[globalVar.curSlide]["positive"]) {
    siAudio.sfx.right.once("end", function() {
      siAudio[globalVar.curSlide]["positive"].play();
    });
    siAudio.sfx.right.play();
  } else {
    siAudio.sfx.right.play();
  }
  
  if (typeof slides[globalVar.curSlide]["onSuccessAction"] === "function") {
    slides[globalVar.curSlide].onSuccessAction();
  }
}

////////////*Feature:Negative Feedback Functions///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function answerIncorrect() {
  var type = slides[globalVar.curSlide].type;
  var trys = slides[globalVar.curSlide][type]['trys'];
  var attempts = slides[globalVar.curSlide][type]['userAttempts'];

  if (attempts === 0) {
    trys = 0
  } else {
    trys++
  }
  slides[globalVar.curSlide][type]['trys'] = trys;

  if (trys < attempts || attempts === 0) {
    $('#' + globalVar.curSlide)
      .find('.si-negative')
      .fadeIn(FBKeyboard)
      .addClass('si-current-modal');

    if (siAudio[globalVar.curSlide]["negative"]) {
      siAudio.sfx.wrong.once('end',function(){
        siAudio[globalVar.curSlide]["negative"].play()
      })
      siAudio.sfx.wrong.play();
    }else{
      siAudio.sfx.wrong.play();
    }

    if (typeof slides[globalVar.curSlide]['onFailureAction1'] === 'function') {
      slides[globalVar.curSlide].onFailureAction1();
    }

  } else if (attempts !== 0 && trys === attempts) {
    $('#' + globalVar.curSlide)
      .find('.si-negative-final')
      .fadeIn(FBKeyboard)
      .addClass('si-current-modal');

    slides[globalVar.curSlide][type]['trys'] = 0;

    if (siAudio[globalVar.curSlide]["negativeFinal"]) {
      siAudio.sfx.wrong.once('end',function(){
        siAudio[globalVar.curSlide]["negativeFinal"].play();
      })
      siAudio.sfx.wrong.play()
    }else{
      siAudio.sfx.wrong.play();
    }

    if (typeof slides[globalVar.curSlide]['onFailureAction2'] === 'function') {
      slides[globalVar.curSlide].onFailureAction2();
    }
  }
  
}
////////////*Feature:Positive and Negative Feedback Handler & closeFeedbackAction///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function handleAnswer(bol) {
  Howler.stop()
  if (slides[globalVar.curSlide]["noFeedback"]) {
    var isNextAction = typeof slides[globalVar.curSlide]["nextAction"] === "function";
    if (bol) {
      if (typeof slides[globalVar.curSlide]["onSuccessAction"] === "function") {
        slides[globalVar.curSlide].onSuccessAction();
      }
    } else {
      if (typeof slides[globalVar.curSlide]["onFailureAction1"] === "function") {
        slides[globalVar.curSlide].onFailureAction1();
      }
    }
    if (isNextAction) {
      slides[globalVar.curSlide].nextAction();
    } else {
      nextSlide();
    }
  } else {
    $("#si-nav-container").addClass("feedback-open");
    if (bol == true) {
      answerCorrect();
    } else {
      answerIncorrect();
    }
  }
}

function closeFeedbackAction(item) {
  var bol = typeof slides[globalVar.curSlide]['nextAction'] === 'function';
  switch (item) {
    case 'si-positive':
      if (bol) {
        slides[globalVar.curSlide].nextAction();
      } else {
        nextSlide();
      }
      break;
    case 'si-negative':
      break;
    case 'si-negative-final':
      if (bol) {
        slides[globalVar.curSlide].nextAction();
      } else {
        nextSlide();
      }
      break;
    default:
      break;
  }
}

function FBKeyboard() {
  // var key = $("#FBKey")
  var FBitems = $('.si-current-modal')
    .children()
    .children();
  var idx;
  if ($(FBitems[0]).hasClass('ie9hack')) {
    idx = 1;
  } else {
    idx = 0;
  }
  $(FBitems[idx]).focus();

  $('body').on('keydown.drag', function (event) {
    switch (event.keyCode) {
      case 9: //cycles through only FB elements while it is open
        event.preventDefault();
        if (idx < FBitems.length - 1) {
          idx += 1;
        } else {
          idx = 0;
        }
        $(FBitems[idx]).focus();
        break;
      case 27: // allows user to press escape key to return to normal and places focus on previous element
        $('.si-current-modal').trigger('click');
        $(document.activeElement).blur();
        break;
      case 13: // allows user to press enter key to return to normal and removes all focus (so that submit key is not clicked when FB closes)
        $('.si-current-modal').trigger('click');
        $(document.activeElement).blur();
        break;
      default:
        return true;
    }
  });
}